<template>
  <div>
    <div class="min-vh">
      <h1
        class="text-center text-sm-left mb-0 mb-sm-3 header-main text-uppercase header-inline"
      >
        MESSAGE REPORT
      </h1>
      <b-container class="px-0 mt-2">
        <b-row class="no-gutters px-0">
          <b-col
            class="text-center text-sm-left mb-3 mb-sm-0"
            cols="12"
            md="6"
            lg="4"
          >
            <label class="ml-2 display-sm-none">Select date : </label>
            <b-dropdown
              id="dropdown-form"
              variant="outline"
              ref="dropdowndate"
              :text="dateType"
              class="m-2 p-0 dropdown-date-custom"
              :class="{
                'bg-white': dateType === 'Custom',
                'bg-header-table': dateType !== 'Custom',
              }"
              menu-class="w-100"
            >
              <div class="px-3 py-2">
                <!-- <b-row class="no-gutters p-3">
                <b-col class="dropdown-date-custom-text">
                  Select Date <span>(select only last 30 days)</span>
                </b-col>
                <b-col class="text-md-right" sm="6">
                  <a @click="resetDate"> Reset </a>
                </b-col>
              </b-row> -->
                <datetime
                  type="datetime"
                  v-model="filter.DateStart"
                  class="date-picker-input"
                  value-zone="Asia/Bangkok"
                  placeholder="dd/mm/yyyy (hh:mm)"
                  :max-datetime="maxStartDate"
                ></datetime>
                <div class="text-center">-</div>
                <datetime
                  type="datetime"
                  v-model="filter.DateEnd"
                  class="date-picker-input"
                  value-zone="Asia/Bangkok"
                  placeholder="dd/mm/yyyy (hh:mm)"
                  :max-datetime="maxDate"
                  :min-datetime="minEndDate"
                ></datetime>
                <div
                  class="d-flex justify-content-end multiselect__bottom mt-1"
                >
                  <span class="clear" @click="clearFilterDate('date')"
                    >Clear</span
                  >
                </div>
                <div class="mt-2">
                  <span class="text-danger" v-if="datetimeCheckError">{{
                    datetimeCheckError
                  }}</span>
                  <b-button
                    class="p-2 w-100 button-color"
                    size="sm"
                    @click="onClickChooseDate('date')"
                    >SUBMIT</b-button
                  >
                </div>
              </div>
            </b-dropdown>
          </b-col>
          <b-col
            class="text-center text-sm-left mb-3 mb-sm-0"
            cols="12"
            md="6"
            lg="4"
          >
            <label class="ml-2 display-sm-none text-nowrap"
              >First Response Time :
            </label>
            <b-dropdown
              id="dropdown-form"
              variant="outline"
              ref="dropdownFirstResponseDate"
              :text="filterDateText(filter.firstResponse)"
              class="m-2 p-0 dropdown-date-custom"
              :class="{
                'bg-white': !filter.firstResponse.filter,
                'bg-header-table': filter.firstResponse.filter,
              }"
              menu-class="w-100"
            >
              <div class="px-3 py-2">
                <datetime
                  type="datetime"
                  v-model="filter.firstResponse.dateStart"
                  class="date-picker-input"
                  value-zone="Asia/Bangkok"
                  placeholder="dd/mm/yyyy (hh:mm)"
                  :max-datetime="maxStartFirstResponseDate"
                ></datetime>
                <div class="text-center">-</div>
                <datetime
                  type="datetime"
                  v-model="filter.firstResponse.dateEnd"
                  class="date-picker-input"
                  value-zone="Asia/Bangkok"
                  placeholder="dd/mm/yyyy (hh:mm)"
                  :max-datetime="maxDate"
                  :min-datetime="minEndFirstResponseDate"
                ></datetime>
                <div
                  class="d-flex justify-content-end multiselect__bottom mt-1"
                >
                  <span
                    class="clear"
                    @click="clearFilterDate('firstResponseTime')"
                    >Clear</span
                  >
                </div>
                <div class="mt-2">
                  <b-button
                    class="p-2 w-100 button-color"
                    size="sm"
                    @click="onClickChooseDate('firstResponseTime')"
                    >SUBMIT</b-button
                  >
                </div>
              </div>
            </b-dropdown>
          </b-col>
          <b-col
            class="text-center text-sm-left mb-3 mb-sm-0"
            cols="12"
            md="6"
            lg="4"
          >
            <label class="ml-2 display-sm-none">Closed Time : </label>
            <b-dropdown
              id="dropdown-form"
              variant="outline"
              ref="dropdownCloseDate"
              :text="filterDateText(filter.closeTime)"
              class="m-2 p-0 dropdown-date-custom"
              :class="{
                'bg-white': !filter.closeTime.filter,
                'bg-header-table': filter.closeTime.filter,
              }"
              menu-class="w-100"
            >
              <div class="px-3 py-2">
                <datetime
                  type="datetime"
                  v-model="filter.closeTime.dateStart"
                  class="date-picker-input"
                  value-zone="Asia/Bangkok"
                  placeholder="dd/mm/yyyy (hh:mm)"
                  :max-datetime="maxStartCloseTimeDate"
                ></datetime>
                <div class="text-center">-</div>
                <datetime
                  type="datetime"
                  v-model="filter.closeTime.dateEnd"
                  class="date-picker-input"
                  value-zone="Asia/Bangkok"
                  placeholder="dd/mm/yyyy (hh:mm)"
                  :max-datetime="maxDate"
                  :min-datetime="minEndCloseTimeDate"
                ></datetime>
                <div
                  class="d-flex justify-content-end multiselect__bottom mt-1"
                >
                  <span class="clear" @click="clearFilterDate('closeTime')"
                    >Clear</span
                  >
                </div>
                <div class="mt-2">
                  <b-button
                    class="p-2 w-100 button-color"
                    size="sm"
                    @click="onClickChooseDate('closeTime')"
                    >SUBMIT</b-button
                  >
                </div>
              </div>
            </b-dropdown>
          </b-col>
          <b-col xl="12" class="text-left text-xl-right">
            <button class="create-button my-2 ml-2" @click="importAllChat()">
              <div>
                <font-awesome-icon icon="plus-square" />
                <span class="ml-1"> IMPORT CHAT</span>
              </div>
            </button>
            <!-- <b-button @click="exportFallbackExcel" class="export-button my-2 ml-2">
              <div>
                <font-awesome-icon icon="file-export" />
                <span class="ml-1"> EXPORT FALLBACK EXCEL </span>
              </div>
            </b-button> -->
            <!-- <b-button @click="exportExcel(1)" class="export-button my-2 ml-2">
              <div>
                <font-awesome-icon icon="file-export" />
                <span class="ml-1"> EXPORT TO EXCEL </span>
              </div>
            </b-button> -->
            <b-button
              @click="$refs.modalExport.show()"
              class="export-button my-2 ml-2"
            >
              <div>
                <font-awesome-icon icon="file-export" />
                <span class="ml-1"> EXPORT TO EMAIL </span>
              </div>
            </b-button>
            <b-dropdown
              id="dropdown-filter"
              variant="outline"
              right
              ref="dropdownfilter"
              class="ml-2 my-2 filter-custom"
              no-flip
            >
              <template v-slot:button-content>
                <font-awesome-icon icon="filter" class="mr-2" />FILTER
              </template>
              <!-- <template v-if="messageChannels.length">
                <div>
                  <p class="mb-2 dropdown-date-custom-text">Channel Type</p>
                </div>
                <b-dropdown-divider></b-dropdown-divider>
                <div class="input-flex-container">
                  <div
                    class="w-100 text-center my-2"
                    v-if="isLoadingChannelType"
                  >
                    <b-spinner small></b-spinner>
                  </div>
                  <div class="w-100" v-else>
                    <b-form-checkbox-group
                      v-model="filter.ChannelType"
                      :options="messageChannels"
                      class="mb-3"
                      value-field="id"
                      text-field="name"
                    ></b-form-checkbox-group>
                  </div>
                </div>
              </template> -->
              <template v-if="channelList.length">
                <div>
                  <p class="mb-2 dropdown-date-custom-text">Channel</p>
                </div>
                <b-dropdown-divider></b-dropdown-divider>
                <div>
                  <div class="input-flex-container">
                    <div
                      class="w-100 text-center my-2"
                      v-if="isLoadingPlatformConfigList"
                    >
                      <b-spinner small></b-spinner>
                    </div>
                    <div v-else>
                      <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-checkbox
                          v-for="option in platformConfigList"
                          v-model="filter.platformConfigId"
                          :key="`platformConfigId-${option.platformConfigId}`"
                          :value="option.platformConfigId"
                          :aria-describedby="ariaDescribedby"
                        >
                          <img
                            width="15"
                            height="15"
                            :src="option.imageUrl"
                            alt=""
                          />
                          {{ option.name }}
                        </b-form-checkbox>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="conversationTopics.length">
                <div>
                  <p class="mb-2 dropdown-date-custom-text">Topic</p>
                </div>
                <b-dropdown-divider></b-dropdown-divider>
                <div>
                  <div class="input-flex-container mb-2">
                    <div class="w-100 text-center my-2" v-if="isLoadingTopic">
                      <b-spinner small></b-spinner>
                    </div>
                    <div class="w-100" v-else>
                      <!-- <b-form-checkbox-group
                        v-model="filter.topicId"
                        :options="conversationTopics"
                        class="mb-3"
                        value-field="id"
                        text-field="name"
                      ></b-form-checkbox-group> -->
                      <multiselect
                        id="topics-dropdown"
                        v-model="filter.topicId"
                        :options="conversationTopicsFilter"
                        :multiple="true"
                        :group-select="false"
                        :close-on-select="false"
                        placeholder="Select Topic"
                        track-by="id"
                        label="name"
                        :option-disabled="(option) => option.isGroup"
                      >
                        <!-- @input="onSelectOption" -->
                        <template v-slot:noResult>ไม่พบข้อมูล</template>
                        <template #option="{ option }">
                          <div
                            v-if="option.isGroup"
                            class="group-header"
                            @mousedown.prevent
                            @click.prevent.stop="toggleGroup(option.groupName)"
                          >
                            <div class="group-name">
                              {{ option.groupName }}
                            </div>
                            <div class="group-icon">
                              {{
                                topicsGroups.includes(option.groupName)
                                  ? "▼"
                                  : "►"
                              }}
                            </div>
                          </div>
                          <div
                            :class="
                              !option.isGroup &&
                              option.groupName &&
                              !topicsGroups.includes(option.groupName)
                                ? 'group-item'
                                : 'item'
                            "
                          >
                            {{ option.name }}
                          </div>
                        </template>
                      </multiselect>
                      <div
                        class="d-flex justify-content-between multiselect__bottom"
                      >
                        <span class="count-selected"
                          >Selected : {{ filter.topicId.length }}</span
                        >
                        <span class="clear" @click="filter.topicId = []"
                          >Clear</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- <div class="d-flex align-items-center">
                <p class="mb-0 mr-2 dropdown-date-custom-text">Status Code :</p>
                <b-form-select
                  v-model="filter.StatusCode"
                  :options="statusCodeLists"
                  size="sm"
                  class="mt-0 w-50"
                ></b-form-select>
              </div> -->
              <div>
                <p class="mb-2 dropdown-date-custom-text">Search</p>
              </div>
              <b-dropdown-divider></b-dropdown-divider>
              <div class="mt-2">
                <multiselect
                  :close-on-select="false"
                  :clear-on-select="false"
                  multiple
                  v-model="filter.userId"
                  :options="customers"
                  placeholder="Select Customer Name"
                  track-by="userGUID"
                  label="socialName"
                ></multiselect>
                <div class="d-flex justify-content-between multiselect__bottom">
                  <span class="count-selected"
                    >Selected : {{ filter.userId.length }}</span
                  >
                  <span class="clear" @click="filter.userId = []">Clear</span>
                </div>
              </div>

              <div class="mt-2">
                <multiselect
                  :close-on-select="false"
                  :clear-on-select="false"
                  multiple
                  v-model="filter.agentGuid"
                  :options="agents"
                  placeholder="Select Agent"
                  track-by="userGUID"
                  label="agentName"
                ></multiselect>
                <div class="d-flex justify-content-between multiselect__bottom">
                  <span class="count-selected"
                    >Selected : {{ filter.agentGuid.length }}</span
                  >
                  <span class="clear" @click="filter.agentGuid = []"
                    >Clear</span
                  >
                </div>
              </div>
              <div class="mt-3">
                <b-button class="w-100 submit-button" @click="onClickSearch">
                  <div>
                    <span> Search </span>
                  </div>
                </b-button>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>
      </b-container>
      <div class="mt-3 bg-white-border p-3">
        <!-- <div class="container-line mb-4">
          <h2 class="font-weight-bold">Overview</h2>
          <b-container class="px-0" fluid>
            <b-row class="no-gutters my-4">
              <b-col lg="3" sm="12" class="mb-3 mb-lg-0">
                <div
                  class="container-borderleft overview-padding mr-lg-2 mr-0 h-100"
                >
                  <div class="mb-4">
                    <font-awesome-icon icon="map" class="mr-2" />
                    <span class="overview-font-size">Current Plan</span>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span class="unit-font text-break">Unit (-)</span>
                    <h1 class="text-break overview-number">
                      {{ currentplan ? currentplan : "-" }}
                    </h1>
                  </div>
                </div>
              </b-col>
              <b-col lg="3" sm="12" class="mb-3 mb-lg-0">
                <div
                  class="container-borderleft overview-padding mr-lg-2 mr-0 h-100"
                >
                  <div class="mb-4">
                    <font-awesome-icon icon="user-friends" class="mr-2" />
                    <span class="overview-font-size">MAU (AS OF TODAY)</span>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span class="unit-font text-break">Unit (People)</span>
                    <h1 class="text-break overview-number">
                      {{ mau | numeral("0,0.00") }}
                    </h1>
                  </div>
                </div>
              </b-col>
              <b-col lg="3" sm="12" class="mb-3 mb-lg-0">
                <div
                  class="container-borderleft overview-padding mr-lg-2 mr-0 h-100"
                >
                  <div class="mb-4">
                    <font-awesome-icon icon="image" class="mr-2" />
                    <span class="overview-font-size">Visual Search</span>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span class="unit-font text-break">Unit (Image)</span>
                    <h1 class="text-break overview-number">
                      {{ imageCount | numeral("0,0") }}/{{
                        requestImage | numeral("0,0")
                      }}
                    </h1>
                  </div>
                </div>
              </b-col>
              <b-col lg="3" sm="12" class="mb-3 mb-lg-0">
                <div class="container-borderleft overview-padding mb-0 h-100">
                  <div class="mb-4">
                    <font-awesome-icon icon="comment-alt" class="mr-2" />
                    <span class="overview-font-size">Message/Sec</span>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span class="unit-font text-break">Unit (message)</span>
                    <h1 class="text-break overview-number">
                      {{ messagePerSec | numeral("0,0.00") }}
                    </h1>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div> -->
        <div>
          <h2 class="font-weight-bold">Message Log</h2>
          <b-row class="main-theme no-gutters mb-3">
            <b-col class="mt-3 w-100">
              <b-table
                responsive
                striped
                hover
                class="table-list"
                :items="messageLists"
                :fields="fields"
                :busy="isBusy"
                show-empty
                :empty-text="$t('noData')"
              >
                <template v-slot:table-busy>
                  <div class="text-center text-black my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(createTime)="data">
                  <span>
                    {{ formatDate(data.item.createTime) }}
                  </span>
                </template>
                <template v-slot:cell(responseTime)="data">
                  <span>
                    {{ formatDate(data.item.responseTime) }}
                  </span>
                </template>

                <template v-slot:cell(completeTime)="data">
                  <span>
                    {{ formatDate(data.item.completeTime) }}
                  </span>
                </template>
                <template v-slot:cell(messageId)="data">
                  <span>
                    {{ data.item.messageId ? data.item.messageId : "-" }}
                  </span>
                </template>
                <template v-slot:cell(displayName)="data">
                  <span v-if="data.item.displayName">
                    {{ data.item.displayName.toString() }}
                  </span>
                  <div v-else>
                    {{ "-" }}
                  </div>
                </template>
                <template v-slot:cell(memberId)="data">
                  <span v-if="data.item.memberId">
                    {{ data.item.memberId.toString() }}
                  </span>
                  <div v-else>
                    {{ "-" }}
                  </div>
                </template>
                <template v-slot:cell(socialName)="data">
                  <div class="d-flex align-items-center">
                    <div class="img-customer mr-3">
                      <b-img
                        v-if="data.item.imageUrl"
                        :src="data.item.imageUrl"
                        blank-color="#8a93a2"
                        rounded="circle"
                        @error="replaceByDefault"
                      />
                      <b-avatar v-else size="40px"></b-avatar>
                    </div>
                    <div>
                      <div class="text-left">
                        {{ data.item.socialName || "-" }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(channelId)="data">
                  <div class="tag-social">
                    <img :src="channels[data.item.channelId].imageUrl" alt="" />
                    <span class="mb-0">{{ data.item.platformConfigName }}</span>
                  </div>
                </template>
                <template v-slot:cell(agentGuid)="data">
                  <div class="d-flex align-items-center">
                    <div class="img-customer mr-3">
                      <b-avatar
                        :text="
                          data.item.agentName
                            ? data.item.agentName.charAt(0)
                            : ''
                        "
                        size="40px"
                      ></b-avatar>
                    </div>
                    <div>
                      <div class="text-left">
                        {{ data.item.agentName || "-" }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(totalScore)="data">
                  <div
                    v-if="
                      data.item.totalScore === null ||
                      data.item.totalScore === undefined
                    "
                  >
                    -
                  </div>
                  <div v-else>
                    <span :class="scoreColor(data.item.totalScore)">{{
                      data.item.totalScore
                    }}</span>
                  </div>
                </template>
                <template v-slot:cell(id)="data">
                  <div class="d-flex justify-content-center">
                    <b-link
                      class="text-link"
                      :to="`/message-log/details/${data.item.messageId}/${data.item.userMessageActivityId}`"
                    >
                      <font-awesome-icon icon="eye" title="View" />
                    </b-link>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row class="no-gutters px-3 px-sm-0">
            <b-col
              class="form-inline justify-content-center justify-content-sm-between"
            >
              <div v-if="rows > 0" class="my-auto">
                Showing {{ startPage | numeral("0,0") }} to
                {{ endPage | numeral("0,0") }} of
                {{ rows | numeral("0,0") }} entires
              </div>
              <div v-else class="my-auto">{{ rows }} entire</div>
              <div class="d-sm-flex m-3">
                <b-pagination
                  v-model="filter.pageNo"
                  :total-rows="rows"
                  :per-page="filter.perPage"
                  class="m-md-0"
                  @change="pagination"
                  align="center"
                ></b-pagination>
              </div>
            </b-col>
          </b-row>
        </div>
        <ModalLoading ref="modalLoading" :text="msgModal" :hasClose="false" />
      </div>
    </div>
    <ModalImportFile ref="modalImportFile" @uploadFile="uploadFile" />
    <ModalExport ref="modalExport" @confirmEmail="exportExcelToEmail" />
  </div>
</template>

<script>
import ModalLoading from "@/components/modal/alert/ModalLoading";
import defaultImg from "@/assets/images/icons/blank.png";
import moment from "moment";
import Multiselect from "vue-multiselect";
import ModalImportFile from "@/components/modal/ModalImportFile";
import ModalExport from "@/components/modal/ModalExport";
import { mapGetters } from "vuex";
export default {
  name: "MessageLog",
  components: {
    ModalLoading,
    Multiselect,
    ModalImportFile,
    ModalExport,
  },
  data() {
    return {
      msgModal: null,
      modalMessage: "",
      minDate: moment().subtract(1, "year").format(),
      maxDate: moment().endOf("day").format(),
      startDate: "",
      isLoadingChannelType: false,
      isLoadingTopic: false,
      isLoadingCustomer: false,
      isLoadingAgent: false,
      dateType: "Custom",
      endDate: "",
      datetimeCheckError: null,
      messageLists: [],
      messageChannels: [],
      conversationTopics: [],
      topicsGroups: [],
      customers: [],
      agents: [],
      statusCodeLists: [
        { value: 0, text: "All" },
        { value: 1, text: "Success" },
        { value: 2, text: "Fail" },
      ],
      messagePerSec: 0,
      mau: 0,
      isBusy: false,
      rows: 0,
      startPage: 1,
      endPage: 10,
      currentplan: 0,
      requestImage: 0,
      imageCount: 0,
      fields: [
        {
          key: "createTime",
          label: "Time",
          class: "w-180px",
        },
        {
          key: "responseTime",
          label: "First Response Time",
          class: "w-180px",
        },
        {
          key: "messageId",
          label: "Message ID",
          class: "w-350px",
        },
        {
          key: "memberId",
          label: "Member ID",
          class: "w-180px",
        },
        {
          key: "socialName",
          label: "Social Name",
          class: "w-180px",
        },
        {
          key: "displayName",
          label: "Display Name",
          class: "w-180px",
        },
        {
          key: "agentName",
          label: "Agent Name",
          class: "w-180px",
        },
        {
          key: "channelId",
          label: "Channel",
          class: "w-180px",
        },
        {
          key: "topicName",
          label: "Topic",
          class: "w-180px",
        },
        {
          key: "agentGuid",
          label: "Agent",
          class: "w-200px",
        },
        {
          key: "totalScore",
          label: "Total Score",
          class: "w-50px",
        },
        {
          key: "completeTime",
          label: "Closed Time",
          class: "w-180px",
        },
        {
          key: "resolutionTimeText",
          label: "Resolution Time",
          class: "w-180px",
        },
        {
          key: "id",
          label: "",
        },
      ],
      filter: {
        DateStart: moment().subtract(7, "days").startOf("day").format(),
        DateEnd: moment().endOf("day").format(),
        pageNo: 1,
        perPage: 10,
        Search: "",
        ChannelType: [1, 2, 3],
        topicId: [],
        userId: [],
        agentGuid: [],
        StatusCode: 0,
        channelId: [],
        firstResponse: {
          filter: false,
          dateStart: moment().subtract(7, "days").startOf("day").format(),
          dateEnd: moment().endOf("day").format(),
        },
        closeTime: {
          filter: false,
          dateStart: moment().subtract(7, "days").startOf("day").format(),
          dateEnd: moment().endOf("day").format(),
        },
        platformConfigId: []
      },
      channels: {},
      channelList: [],
      isLoadingChannelList: false,
      platformConfigList: [],
      isLoadingPlatformConfigList: false,
    };
  },
  created: async function () {
    await this.getAllPlatformConfig();
    await this.getChannel();
    await this.getConversationTopics();
    await this.getCustomers();
    await this.getAgents();
    await this.getAllData();
    this.getShowingPage(1);
  },
  computed: {
    ...mapGetters(["getBrandDetail"]),

    maxStartDate() {
      return moment(this.filter.DateEnd).endOf("day").format();
    },
    minEndDate() {
      return moment(this.filter.DateStart).startOf("day").format();
    },
    maxStartFirstResponseDate() {
      return moment(this.filter.firstResponse.dateEnd).endOf("day").format();
    },
    minEndFirstResponseDate() {
      return moment(this.filter.firstResponse.dateStart)
        .startOf("day")
        .format();
    },
    maxStartCloseTimeDate() {
      return moment(this.filter.closeTime.dateEnd).endOf("day").format();
    },
    minEndCloseTimeDate() {
      return moment(this.filter.closeTime.dateStart).startOf("day").format();
    },
    conversationTopicsFilter() {
      return this.conversationTopics.flatMap((group) => {
        const hasGroup = group.groupName;

        const headerGroup = hasGroup
          ? [{ isGroup: true, groupName: group.groupName }]
          : [];

        const items = group.topics.map((item) => ({
          ...item,
          groupName: group.groupName || null,
        }));

        return [...headerGroup, ...items];
      });
    },
  },
  methods: {
    getAllData: async function () {
      await this.getMessageLog();
      // await this.getMessagePerSec();
      // await this.getMAU();
      // await this.getCurrentPlan();
      // await this.getVisualSearch();
    },
    scoreColor(score) {
      const qualificationScore = this.getBrandDetail()?.qualificationScore || 0;
      return score >= qualificationScore
        ? "text-color-primary"
        : "text-color-red";
    },
    getMessageLog: async function () {
      this.isBusy = true;
      let filter = { ...this.filter };

      filter.userId = await filter.userId.map((e) => e.userGUID);
      filter.agentGuid = await filter.agentGuid.map((e) => e.userGUID);
      filter.topicId = await filter.topicId.map((e) => e.id);

      await this.axios
        .post(`${this.$baseUrl}/messagelog/GetMessageLog`, filter)
        .then((data) => {
          if (data.result === 1) {
            this.messageLists = data.detail.data;
            this.rows = data.detail.count;
            this.isBusy = false;
          }
        });
    },
    getMessageChannelType: async function () {
      this.isLoadingChannelType = true;
      await this.axios(`${this.$baseUrl}/masterdata/MessageChannelType`)
        .then((data) => {
          if (data.result === 1) {
            this.messageChannels = data.detail;
            this.isLoadingChannelType = false;
          }
        })
        .catch((error) => {
          this.messageChannels = [];
          this.isLoadingChannelType = false;
        });
    },
    getConversationTopics: async function () {
      this.isLoadingTopic = true;
      await this.axios(`${this.$baseUrl}/FlowBuilder/Topics`)
        .then((data) => {
          if (data.result === 1) {
            this.conversationTopics = data.detail;
            this.isLoadingTopic = false;
          }
        })
        .catch((error) => {
          this.conversationTopics = [];
          this.isLoadingTopic = false;
        });
    },
    getCustomers: async function () {
      this.isLoadingCustomer = true;
      await this.axios(`${this.$baseUrl}/customer/list/customer`)
        .then((data) => {
          if (data.result === 1) {
            this.customers = data.detail;
            this.isLoadingCustomer = false;
          }
        })
        .catch((error) => {
          this.customers = [];
          this.isLoadingCustomer = false;
        });
    },
    getAgents: async function () {
      this.isLoadingAgent = true;
      await this.axios(`${this.$baseUrl}/customer/list/Agent`)
        .then((data) => {
          if (data.result === 1) {
            this.agents = data.detail;
            this.isLoadingAgent = false;
          }
        })
        .catch((error) => {
          this.agents = [];
          this.isLoadingAgent = false;
        });
    },
    getMessagePerSec: async function () {
      await this.axios(`${this.$baseUrl}/messagelog/GetMsgPerSec`).then(
        (data) => {
          if (data.result === 1) {
            this.messagePerSec = data.detail;
          }
        }
      );
    },
    getMAU: async function () {
      await this.axios
        .post(`${this.$baseUrl}/messagelog/GetMAU`, this.filter)
        .then((data) => {
          if (data.result === 1) {
            this.mau = data.detail;
          }
        });
    },
    getCurrentPlan: async function () {
      await this.axios(`${this.$baseUrl}/CurrentPlan`).then((data) => {
        if (data.result === 1) {
          this.currentplan = data.detail.planName;
          this.requestImage = data.detail.requestImage;
        }
      });
    },
    getVisualSearch: async function () {
      await this.axios(`${this.$baseUrl}/messagelog/GetImageCount`).then(
        (data) => {
          if (data.result === 1) {
            this.imageCount = data.detail;
          }
        }
      );
    },
    onClickSearch: async function () {
      this.$refs.dropdownfilter.hide(false);
      await this.getAllData();
    },
    clearFilterDate: async function (type) {
      const defaultStartDate = moment()
        .subtract(1, "months")
        .startOf("day")
        .format();
      const defaultEndDate = moment().endOf("day").format();
      switch (type) {
        case "date":
          this.filter.DateStart = defaultStartDate;
          this.filter.DateEnd = defaultEndDate;
          this.$refs.dropdowndate.hide(false);
          this.dateType = "Custom";
          break;
        case "firstResponseTime":
          this.filter.firstResponse.filter = false;
          this.filter.firstResponse.dateStart = defaultStartDate;
          this.filter.firstResponse.dateEnd = defaultEndDate;
          this.$refs.dropdownFirstResponseDate.hide(false);
          break;
        case "closeTime":
          this.filter.closeTime.filter = false;
          this.filter.closeTime.dateStart = defaultStartDate;
          this.filter.closeTime.dateEnd = defaultEndDate;
          this.$refs.dropdownCloseDate.hide(false);
          break;

        default:
          break;
      }
      this.getAllData();
    },
    filterDateText: function (val) {
      return !val.filter
        ? "Custom"
        : `${this.formatDate(
            val.dateStart ? val.dateStart : val.DateStart
          )} - ${this.formatDate(val.dateEnd ? val.dateEnd : val.DateEnd)}`;
    },
    onClickChooseDate: async function (type) {
      switch (type) {
        case "date":
          if (this.filter.DateStart && this.filter.DateEnd) {
            this.datetimeCheckError = null;
            this.dateType = `${this.formatDate(
              this.filter.DateStart
            )} - ${this.formatDate(this.filter.DateEnd)}`;

            this.$refs.dropdowndate.hide(false);
            await this.getAllData();
            this.getShowingPage(1);
          } else {
            this.datetimeCheckError = "Please Choose Start and End";
          }
          break;
        case "firstResponseTime":
          this.filter.firstResponse.filter = true;
          this.$refs.dropdownFirstResponseDate.hide(false);
          await this.getAllData();
          this.getShowingPage(1);
          break;
        case "closeTime":
          this.filter.closeTime.filter = true;
          this.$refs.dropdownCloseDate.hide(false);
          await this.getAllData();
          this.getShowingPage(1);
          break;
        default:
          break;
      }
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getMessageLog();
      this.getShowingPage(Page);
    },
    async getShowingPage(page) {
      let result = await this.$getShowingPage(page, this.filter);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
    },
    async exportFallbackExcel() {
      this.$refs.modalLoading.show();
      this.msgModal = "In progress";
      try {
        const body = {
          DateStart: this.filter.DateStart,
          DateEnd: this.filter.DateEnd,
        };
        await this.axios
          .post(`${this.$baseUrl}/messagelog/GetFallbackExcel`, body)
          .then((data) => {
            this.$refs.modalLoading.hide();
            if (data.result === 1) {
              this.$store.commit("UPDATE_GLOBAL_ALERT", {
                isShow: true,
                msg: this.$t('fileUploadSuccess'),
              });
            } else {
              this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
                isShow: true,
                msg: this.$t('fileUploadFail'),
              });
            }
          });
      } catch (err) {
        console.error(err);
        this.$refs.modalLoading.hide();
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: this.$t('fileUploadFail'),
        });
      }
    },
    async exportExcelToEmail(response) {
      this.$refs.modalLoading.show();
      this.msgModal = "In progress";
      try {
        const body = {
          ...response,
          ...this.filter,
        };

        body.userId = await body.userId.map((e) => e.userGUID);
        body.agentGuid = await body.agentGuid.map((e) => e.userGUID);
        body.topicId = await body.topicId.map((e) => e.id);
        delete body.pageNo;
        delete body.perPage;

        await this.axios
          .post(`${this.$baseUrl}/messagelog/Export/GetMessageLogEmail`, body)
          .then((data) => {
            this.$refs.modalLoading.hide();
            if (data.result === 1) {
              this.$store.commit("UPDATE_GLOBAL_ALERT", {
                isShow: true,
                msg: data.detail, //`ทำการส่งไฟล์สำเร็จ`,
              });
              this.$refs.modalExport.hide();
            } else {
              this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
                isShow: true,
                msg: this.$t('fileUploadFail'),
              });
            }
          });
      } catch (err) {
        console.error(err);
        this.$refs.modalLoading.hide();
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: this.$t('fileUploadFail'),
        });
      }
    },
    async exportExcel(typeNumber) {
      this.$refs.modalLoading.show();
      this.msgModal = "In progress";

      const body = {
        ...this.filter,
      };

      body.userId = await body.userId.map((e) => e.userGUID);
      body.agentGuid = await body.agentGuid.map((e) => e.userGUID);
      body.topicId = await body.topicId.map((e) => e.id);
      delete body.pageNo;
      delete body.perPage;

      let path = "";
      let fileName = "";

      if (typeNumber == 1) {
        path = "messagelog/export/GetMessageLog";
        fileName = "Message-Log";
      }

      try {
        await this.axios
          .post(`${this.$baseUrl}/${path}`, body, {
            responseType: "blob",
          })
          .then(async (response) => {
            this.$refs.modalLoading.hide();
            const isJsonBlob = (data) =>
              data instanceof Blob && data.type === "application/json";
            const responseData = isJsonBlob(response)
              ? await response?.text()
              : response || {};
            if (typeof responseData === "string") {
              const responseJson = JSON.parse(responseData);
              this.$refs.modalLoading.hide();
              this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
                isShow: true,
                msg: responseJson.message,
              });
            } else {
              var fileURL = window.URL.createObjectURL(new Blob([response]));
              var fileLink = document.createElement("a");
              var startDate = moment(this.filter.DateStart).format("YYYYMMDD");
              var endDate = moment(this.filter.DateEnd).format("YYYYMMDD");

              fileLink.href = fileURL;
              fileLink.setAttribute(
                "download",
                `${fileName}_${startDate}-${endDate}.xlsx`
              );
              document.body.appendChild(fileLink);
              fileLink.click();
            }
          })
          .catch((error) => {
            console.log(error);
            this.$refs.modalLoading.hide();
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: error.message,
            });
          });
      } catch (err) {
        console.error(err);
        this.$refs.modalLoading.hide();
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: error.message,
        });
      }
    },
    replaceByDefault(e) {
      e.target.src = defaultImg;
    },
    getAllPlatformConfig: async function () {
      this.isLoadingPlatformConfigList = true;
      const url = `${this.$baseUrl}/analytics/get-all-platform-config`;
      await this.axios.get(url).then(async (data) => {
        if (data.result === 1) {
          this.platformConfigList = data.detail;
        }
        this.isLoadingPlatformConfigList = false;
      });
      this.isLoadingPlatformConfigList = false;
    },
    getChannel: async function () {
      this.isLoadingChannelList = true;
      const url = `${this.$baseUrl}/analytics/Filter/Channel`;
      await this.axios.get(url).then(async (data) => {
        if (data.result === 1) {
          this.channelList = data.detail;
          await data.detail.forEach((item) => {
            this.channels[item.id] = item;
          });
        }
        this.isLoadingChannelList = false;
      });
      this.isLoadingChannelList = false;
    },
    importAllChat() {
      this.$refs.modalImportFile.show();
    },
    async uploadFile(item) {
      this.$refs.modalLoading.show();
      this.msgModal = "In progress";
      try {
        let body = {
          file: item.File,
        };
        await this.axios
          .post(`${this.$baseUrl}/messagelog/Import/AllChatHistory`, body)
          .then((data) => {
            this.$refs.modalLoading.hide();
            if (data.result === 1) {
              this.$store.commit("UPDATE_GLOBAL_ALERT", {
                isShow: true,
                msg: this.$t('fileImportSuccess'),
              });
              this.pagination(1);
              this.$refs.modalImportFile.hide();
            } else {
              console.error(data);
              this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
                isShow: true,
                msg: this.$t('fileImportFail'),
              });
            }
          });
      } catch (err) {
        console.error(err);
        this.$refs.modalLoading.hide();
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: this.$t('fileImportFail'),
        });
      }
    },
    toggleGroup(groupName) {
      const index = this.topicsGroups.indexOf(groupName);
      if (index > -1) {
        this.topicsGroups.splice(index, 1);
      } else {
        this.topicsGroups.push(groupName);
      }
      this.filter.topicId = this.filter.topicId.filter((item) => !item.isGroup);
    },
    onSelectOption(option) {
      const filtered = option.filter((item) => !item.isGroup);
      this.filter.topicId = filtered;
    },
  },
};
</script>

<style lang="scss" scoped>
.break-all {
  word-break: break-all;
}

.textbody {
  width: 400px;
  word-break: break-all;
}

.submit-button {
  background-color: #5b57a5;
  color: white;
  border-radius: 4px;
}

.unit-font {
  font-size: 14px;
  color: #575757;
}

.container-borderleft {
  border-left: 5px solid #7160c4;
  background-color: #e2dff3;
}

.padding-rem {
  padding: 0.5rem 1.25rem;
}

.dropdown-date-custom {
  border-radius: 3px;
  width: 98%;
}

.dropdown-date-custom-text {
  color: #575757 !important;
}

.text-color-red {
  color: red;
}

.text-color-primary {
  color: #7160c4;
}

.search-button {
  background-color: #ffffff;
  text-align: center !important;
  border-left: 0;
  color: #575757;
}

.button-color {
  background-color: #8f20c6;
  text-align: center !important;
  color: white;
}

.container-line {
  border-bottom: 1px solid #bebebe;
}

a {
  text-decoration: underline;
  color: #7160c4;
}

a:hover {
  cursor: pointer;
}

label {
  color: #8b8b8b;
}

.input-flex-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

::v-deep .dropdown-menu-right {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}

.overview-padding {
  padding: 16px;
  @media screen and (max-width: 1240px) and (min-width: 990px) {
    padding: 16px 8px;
  }
}

.overview-number {
  font-size: 27px;
  @media screen and (max-width: 1240px) and (min-width: 990px) {
    font-size: 24px;
  }
}

.overview-font-size {
  font-size: 16px;
  @media screen and (max-width: 1240px) and (min-width: 990px) {
    font-size: 14px;
  }
}
.create-button {
  font-weight: bold;
  min-height: 35px;
}
.export-button {
  background-color: #0d1731;
  color: #ffffff !important;
  min-width: 150px;
  font-weight: bold;
  transition: 0.3s;
  border-radius: 4px;
  border-color: #0d1731;
}
.img-customer,
.img-customer img {
  width: 40px;
  height: 40px;
}

.display-sm-none {
  @media screen and (max-width: 657px) {
    display: none;
  }
}

.header-inline {
  display: inline;
  @media screen and (max-width: 1200px) {
    display: block;
  }
}

::v-deep .multiselect__option {
  :has(.group-header) {
    padding: 0 !important;
  }
}
::v-deep .multiselect__element {
  :has(.group-header) {
    color: #35495e;
    background-color: #f0f0f0;
    padding: 0 !important;
    &:hover {
      background-color: #b41bb4;
      color: #ffffff;
    }

    &::after {
      display: none;
    }
  }

  :has(.group-item) {
    display: none !important;
  }

  span {
    padding-left: 10px;
  }
}

::v-deep .multiselect__tag {
  max-width: 300px;
}

::v-deep .multiselect__element {
   span {
    max-width: 530px;
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

}

.group-header {
  padding: 12px 12px 15px 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: #f0f0f0;

  .group-icon {
    font-size: 10px;
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
  }
}

.group-header:hover {
  background-color: #b41bb4;
}

.group-item,
.item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding-left: 10px;
}
</style>
